import {ChangeDetectionStrategy, Component} from "@angular/core";
import {IntButtonComponent} from "../int-button";

@Component({
  selector: 'button[int-bordered-button], a[int-bordered-button]',
  template: `<span class="inner-content"><ng-content></ng-content></span>`,
  styleUrls: ['./int-bordered-button.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush
})
export class IntBorderedButtonComponent extends IntButtonComponent {

  setClasses() {
    this.classes = `${this.mode}-bordered-mode ${this.size} ${this.freeWidth ? 'free-width': 'limit-width'} ${this.breakWords ? 'int-btn-break-words' : ''}`;
  }
}
